var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    height: "50%",
    width: "50%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C2 9.76 2 10.04 2 10.6V19M15.5 9h2.9c.56 0 .84 0 1.054.109a1 1 0 01.437.437C20 9.76 20 10.04 20 10.6V19m-4.5 0V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C13.98 1 13.42 1 12.3 1H9.7c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C6.5 2.52 6.5 3.08 6.5 4.2V19M21 19H1m9-14h2m-2 4h2m-2 4h2"
  })));
}
export default __webpack_public_path__ + "static/media/building.09b8fcd0.svg";
export { SvgBuilding as ReactComponent };